<template>
  <div class="content">
    <div class="main">

        <div class="container text-center">
          <h2>{{ title }}</h2>
        </div>

        <div class="container">

        </div>

    </div>
  </div>
</template>

<script>
import * as MusicData from '@/data/music_data'

export default {
  name: "Sensory",
  components: {
  },
  data() {
    return {
      title: "Sensory",
      rootKeys: MusicData.notes,
      chords: {
        rootKey: 'C'
      }
    };
  },
  mounted: function () {
  },
  methods: {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
h1,
.h1 {
  font-family: "kingthings_organicaextra_bold", Impact, "Arial Black",
    sans-serif;
}
</style>
